export default {"src":"/_next/static/media/Error-primary.b4a086d6.svg","height":56,"width":56};